import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const CandidateProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const candidate = {
    name: 'Yaw Mensah',
    role: 'Operations Manager',
    email: 'yaw.m@example.com',
    phone: '+233 55 987 6543',
    location: 'Kumasi, Ghana',
    experience: '8 Years',
    skills: ['Logistics', 'Supply Chain', 'Team Leadership', 'Strategic Planning', 'Inventory Management', 'Lean Six Sigma'],
    education: 'MBA in Management, KNUST',
    summary: 'Seasoned operations professional with a proven track record of optimizing supply chain workflows and leading large cross-functional teams in the manufacturing sector. Expert in cost reduction strategies and operational excellence through data-driven decision making.'
  };

  return (
    <div className="max-w-5xl space-y-12 pb-10">
      <button 
        onClick={() => navigate(-1)} 
        className="flex items-center gap-2 text-[11px] font-bold text-gray-500 hover:text-[#11469A] transition-colors uppercase tracking-widest"
      >
        <SafeIcon name="ArrowLeft" size={14} /> Back to Candidates
      </button>

      {/* Header Section */}
      <div className="flex flex-col md:flex-row items-start gap-8">
        <div className="shrink-0 bg-white p-2 rounded-3xl shadow-sm">
          <img 
            src="https://images.unsplash.com/photo-1520341280432-4749d4d7bcf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" 
            className="w-36 h-36 rounded-2xl object-cover" 
            alt="Candidate Avatar" 
          />
        </div>
        <div className="flex-1 space-y-3 pt-2">
          <div className="flex flex-wrap gap-3">
            <span className="px-2.5 py-1 bg-green-50 text-green-600 text-[10px] font-bold uppercase tracking-widest rounded">Shortlisted</span>
            <span className="px-2.5 py-1 bg-blue-50 text-[#11469A] text-[10px] font-bold uppercase tracking-widest rounded">Top 5% Match</span>
          </div>
          <h1 className="text-3xl font-extrabold text-gray-800 m-0">{candidate.name}</h1>
          <h2 className="text-sm font-bold text-[#11469A] uppercase tracking-widest m-0">{candidate.role}</h2>
          <div className="flex flex-wrap items-center gap-6 pt-2 text-sm text-gray-500 font-medium">
            <span className="flex items-center gap-2"><SafeIcon name="Mail" size={16} className="text-gray-400" /> {candidate.email}</span>
            <span className="flex items-center gap-2"><SafeIcon name="Phone" size={16} className="text-gray-400" /> {candidate.phone}</span>
            <span className="flex items-center gap-2"><SafeIcon name="MapPin" size={16} className="text-gray-400" /> {candidate.location}</span>
          </div>
        </div>
      </div>

      {/* Summary Section */}
      <div className="space-y-4 pt-4">
        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <SafeIcon name="User" size={20} className="text-[#11469A]" />
          Professional Summary
        </h3>
        <p className="text-gray-600 leading-relaxed text-[15px] font-medium max-w-4xl">
          {candidate.summary}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 pt-4">
        {/* Core Competencies */}
        <div className="space-y-6">
          <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <SafeIcon name="Zap" size={20} className="text-yellow-500" />
            Core Competencies
          </h3>
          <div className="flex flex-wrap gap-3">
            {candidate.skills.map(skill => (
              <span key={skill} className="px-4 py-2 bg-white text-gray-700 shadow-sm rounded-lg text-[11px] font-bold uppercase tracking-wider">
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Education & Certifications */}
        <div className="space-y-6">
          <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <SafeIcon name="BookOpen" size={20} className="text-purple-600" />
            Education & Certifications
          </h3>
          <div className="pt-2">
            <h4 className="font-bold text-gray-800 text-base">{candidate.education}</h4>
            <p className="text-sm text-gray-500 mt-1 font-medium">Kwame Nkrumah University of Science and Technology</p>
            <div className="flex items-center gap-2 mt-4 text-[11px] font-bold text-[#11469A] uppercase tracking-widest">
              <SafeIcon name="Calendar" size={14} /> Class of 2015
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateProfile;